import apiClient from "@services/apiClient";
import { ATP_API_URL } from "@config/apiconfig";

export const fetchBookingList = async (urlParams) => {
  try {
    let url = ATP_API_URL.GET_ALL_POLICIES;

    if (urlParams) {
      url = `${url}?${urlParams}`;
    }

    const response = await apiClient.get(url);

    if (response?.data?.success) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};
